import * as S from '../styled';
import {NameSpan} from '../styled';
import {useSelector} from "react-redux";
import {dialogs, hideRemoveFromBlackListDialog, loadings} from "../../../store/slice";
import {useAppDispatch} from "../../../../../../newShared/redux";
import React, {useEffect, useState} from "react";
import {Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {useMainTranslation} from "../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {TypographyBody1} from "../../../../../../newShared/components/Inputs/styled";
import CommonCheckbox from "../../../../../../newShared/components/Basic/CommonCheckBox";
import {LoadingButton} from "../../../../../../newShared/components/Basic/CommonButtons";
import {RestoreKycTargetFromBlackList} from "../../../store/actions";
import {getTargetName} from "../../../helpers";


export const RestoreClientFromBlackListDialog = () => {
    const {t, tCommon} = useMainTranslation('', {keyPrefix: 'pathKYCRefactor.dialogs'});

    const dispatch = useAppDispatch();
    const {isOpen, selectedClient} = useSelector(dialogs).removeFromBlackList;
    const {moveFromBlacklist} = useSelector(loadings);
    const [isDescription, setIsDescription] = useState<boolean>(false);
    const [description, setDescription] = useState<string>('');
    const handleClose = () => {
        dispatch(hideRemoveFromBlackListDialog());
    }

    const handleSave = () => {
        selectedClient && dispatch(RestoreKycTargetFromBlackList({workspaceId: '', targetId: selectedClient.id, description}));
    }

    useEffect(() => {
        if (isOpen) {
            setIsDescription(false)
            setDescription('');
        }

        //eslint-disable-next-line
    }, [isOpen]);



    return (
        <S.CommonDialog open={isOpen} onClose={handleClose}>
            <DialogTitle>{t('Restore from black list')}</DialogTitle>
            <DialogContent>
                { selectedClient && <TypographyBody1>
                    {`${t('Client name')}: `}
                    <NameSpan>{getTargetName(selectedClient)}</NameSpan>
                </TypographyBody1>}
                <TypographyBody1>{t('You’re about to restore client from black list.')}</TypographyBody1>
                <CommonCheckbox label={t('Provide reason for restoring from black list')} checked={isDescription} onChange={() => setIsDescription(!isDescription)} />

                {isDescription && <TextField minRows={3}
                                             multiline
                                             value={description}
                                             onChange={(e) => setDescription(e.target.value)}
                                             label={t('Reason for restoring')} />}

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant={'text'} sx={{textTransform: 'none'}}>{tCommon('Cancel')}</Button>
                <LoadingButton disabled={moveFromBlacklist}
                               onClick={handleSave} loading={moveFromBlacklist }
                               loadingPosition={moveFromBlacklist ? 'end' : undefined}
                >
                    {t('Restore')}
                </LoadingButton>
            </DialogActions>
        </S.CommonDialog>
    )
}
